import {ResourceParams} from "./resources";

export type SelectResourceType =
  | 'product-cards-defects'
  | 'product-cards-defect-values';

export const selectResources: {
  [key in SelectResourceType]: ResourceParams
} = {
  'product-cards-defects': {
    key: 'product-cards-defects',
    name: '',
    path: 'product-cards-defects',
  },
  'product-cards-defect-values': {
    key: 'product-cards-defect-values',
    name: '',
    path: 'product-cards-defect-values',
  }
};
